import { render } from "./NotificationsModal.vue?vue&type=template&id=8de17b34&scoped=true"
import script from "./NotificationsModal.vue?vue&type=script&lang=js"
export * from "./NotificationsModal.vue?vue&type=script&lang=js"

import "./NotificationsModal.vue?vue&type=style&index=0&id=8de17b34&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de17b34"]])

export default __exports__